import { render, staticRenderFns } from "./KnowledgeContentDeleteConfirm.vue?vue&type=template&id=b66627a0&"
import script from "./KnowledgeContentDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports